module.exports = __webpack_public_path__ + "img/numberly__logo__desktop.c09b5813.png";